module.exports = __webpack_public_path__ + "media/en_au_s1_Daymion.02b20295.mp3";